var map = {
	"./17-bm.webp": 1167,
	"./17-cn.webp": 1168,
	"./17.webp": 1169,
	"./27-bm.webp": 1170,
	"./27-cn.webp": 1171,
	"./27.webp": 1172,
	"./7-bm.webp": 1173,
	"./7-cn.webp": 1174,
	"./7.webp": 1175,
	"./angpao-bg-mobile.jpg": 1176,
	"./angpao-bg.jpg": 1177,
	"./angpao-bm.webp": 1178,
	"./angpao-cn.webp": 1179,
	"./angpao.webp": 1180,
	"./button.png": 1181,
	"./close-eye.png": 1182,
	"./coin-1.png": 1183,
	"./coin.png": 1184,
	"./ketupak-open.png": 1185,
	"./ketupak.png": 1186,
	"./ketupak_ribbon.png": 1187,
	"./rain-1.png": 1188,
	"./rain-2.png": 1189,
	"./rain-3.png": 1190,
	"./raya-bg-mobile.png": 1191,
	"./raya-bg.png": 1192,
	"./shine.png": 1193,
	"./star-1.png": 1194,
	"./star-2.png": 1195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;